// Small helper to build hreflang / canonical urls consistently
export const SITE_URL = "https://adalcrea.com";

export const buildCanonical = (path = "/") => {
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${clean === "/" ? "" : clean}`;
};
